import {useTranslation} from "react-i18next";
export function GetMessages(){
    const {t:trans} = useTranslation(['mobileMessages']);
    const messages = {
        "any.required": trans("mobileMessages:field_required"),
        "string.base": trans("mobileMessages:type_input_field"),
        "string.email": trans("mobileMessages:email_input_field"),
        "string.empty": trans("mobileMessages:empty_field"),
        "string.min": trans("mobileMessages:min_input_field"),
        "string.max": trans("mobileMessages:max_input_field"),
        "string.pattern.base": trans("mobileMessages:flag_input_field"),
        "object.base": trans("mobileMessages:file_input_field"),
        "binary.max": trans("mobileMessages:file_max_input_field"),
        "date.base": trans("mobileMessages:date_input_field"),
        "any.only": trans("mobileMessages:password-not-matched"),
        "number.base": trans("mobileMessages:number_input_field"),
        "number.positive": trans("mobileMessages:number_pos_input_field"),
        "number.min": trans("mobileMessages:number_min_input_field"),
        "number.max": trans("mobileMessages:number_max_input_field"),
        "string.length": trans("mobileMessages:flag_length_field")
    }
    return messages;
}
export function formValidate(schema,data){  
const {error,value} =   schema.validate(data,{abortEarly:false});
if(!error) return null;
//alert(JSON.stringify(error.details));
const errors ={};
for(let item of error.details){
    if(item.type != 'object.unknown')
        errors[item.path[0]] = item.message;
}
return errors;
}

export function validateProperty({name,value},schema){
const obj = {[name]:value};
const {error} = schema.validate(obj,{abortEarly:false});
return error ? error.details[0].message : null;
}